import React from 'react';

import video1 from 'assets/images/landingAir/air-insights/real-time-air-alert.mp4';
import video2 from 'assets/images/landingAir/air-insights/current-room-status.mp4';
import video3 from 'assets/images/landingAir/air-insights/monthly-home-health-report.mp4';
import video4 from 'assets/images/landingAir/air-insights/life-saving-co-sensor.mp4';

import video1Thumbnail from 'assets/images/landingAir/air-insights/real-time-air-alert-thumbnail.jpg';
import video2Thumbnail from 'assets/images/landingAir/air-insights/current-room-status-thumbnail.jpg';
import video3Thumbnail from 'assets/images/landingAir/air-insights/monthly-home-health-report-thumbnail.jpg';
import video4Thumbnail from 'assets/images/landingAir/air-insights/life-saving-co-sensor-thumbnail.jpg';

export const airInsightsStatic = [
  {
    id: 1,
    duration: 10000,
    title: (
      <>
        Your home’s health,
        <br />
        on display.
      </>
    ),
    content:
      'Mila tips you off when something isn\'t right and lets you know when everything is ok—in plain (and fun!) English.',
    videoUrl: video1,
    poster: video1Thumbnail,
  },
  {
    id: 2,
    duration: 3000,
    title: (
      <>
        Peace of mind,
        <br />
        in your pocket.
      </>
    ),
    content:
      'Is the air in the kids’ room ok? Has your living room been struck by the evening’s fish dinner? Check in on your home anytime, from anywhere, through Mila’s mobile app.',
    videoUrl: video2,
    poster: video2Thumbnail,
  },
  {
    id: 3,
    duration: 25000,
    title: (
      <>
        Your air quality,
        <br />
        demystified.
      </>
    ),
    content:
      'Mila is the first purifier to deliver a comprehensive monthly home health report, revealing air trends she’s uncovered in your home and neighborhood. Airblivious? Nope, not you.',
    videoUrl: video3,
    poster: video3Thumbnail,
  },
  {
    id: 4,
    duration: 4000,
    title: (
      <>
        Looking out for you
        {' '}
        <br />
        and your entire crew.
      </>
    ),
    content:
      'Mila is the first air purifier equipped with a carbon monoxide sensor, so you’ll know if this odorless gas might be lurking in your air.',
    videoUrl: video4,
    poster: video4Thumbnail,
  },
];
